import React from 'react';

/* Horizontal percentage bars for the academic rates. Ported from `RateBar` in
   MatchDetailSheet.swift: fixed 118px label, flexible track, fixed 40px value.

   `tone` groups related rates (green = who gets in and stays, blue = who
   finishes, gray = the two recessive rates) but never carries meaning alone —
   each row is labeled and shows its number. */

export default function RateBar({ rows }) {
  const shown = rows.filter((r) => r.pct != null);
  if (shown.length === 0) return null;

  return (
    <div className="sd-chart">
      {shown.map((row) => {
        const width = `max(2px, ${Math.min(Math.max(row.pct, 0), 100)}%)`;
        return (
          <div className={`sd-rate sd-rate--${row.tone}`} key={row.label}>
            <span className="sd-rate__label">{row.label}</span>
            <div className="sd-rate__track">
              <div className="sd-track" role="img" aria-label={`${row.label}: ${row.pct} percent`}>
                <div className="sd-track__fill" style={{ width }} />
              </div>
            </div>
            <span className="sd-rate__value">{row.pct}%</span>
          </div>
        );
      })}
    </div>
  );
}
